/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMOsisRuleListConfiguration
 */
export interface BCMOsisRuleListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof BCMOsisRuleListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof BCMOsisRuleListConfiguration
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
}

export function BCMOsisRuleListConfigurationFromJSON(json: any): BCMOsisRuleListConfiguration {
    return BCMOsisRuleListConfigurationFromJSONTyped(json, false);
}

export function BCMOsisRuleListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMOsisRuleListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
    };
}

export function BCMOsisRuleListConfigurationToJSON(value?: BCMOsisRuleListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


